import * as z from "zod";

export const createSupportAiAndBaseSubscription = {
  name: "createSupportAiAndBaseSubscription" as const,
  input: z.object({}).optional(),
  output: z.object({
    success: z.boolean(),
    confirmationUrl: z.string().url().optional(),
  }),
};
